import { createSelector } from 'reselect'

export const statsSelector = (state) => state.stats.stats || {}

export const selectStats = createSelector(
  [statsSelector],
  (stats) => {
    return {
      stats,
    }
  },
)

export const selectStatsGroupedByParamsHash = createSelector(
  [selectStats],
  ({ stats }) => {
    return {
      statsGroupedByParamsHash: stats.byParamsHash || {},
    }
  },
)
